<template>
  <section class="section-auth p-tb-25 bg-lighter">
    <div class="container-mini">
      <div class="text-center m-b-25">
        <router-link :to="{ name: 'home' }">
          <img src="../../assets/images/logo-color.png" alt="Logo" class="h-65" />
        </router-link>
      </div>

      <slot />

    </div>
  </section>
</template>

<script>
export default {};
</script>

